export const HOMEPAGE = "/";

// AUTH
export const SIGN_UP = "/sign-up";
export const SIGN_IN = "/sign-in";
export const FORGOT_PASSWORD = "/forgot-password";

// ONBOARDING
export const ONBOARDING = "/onboarding";

// PROFILES
export const PROFILE = "/u/:username";

//////////////
// SETTINGS //
//////////////

// GENERAL
export const SETTINGS = "/settings";

//////////////
// PROJECTS //
//////////////

// PROJECTS
export const CREATE_PROJECT = "/create-project";
export const EDIT_PROJECT = "/edit-project/:id";
export const PROJECTS_HOME = "/projects";
export const PROJECT_DETAIL = "/project/:id";

// UPDATES
export const UPDATES = "/updates";

// CREATIVES
export const CREATIVES_HOME = "/creatives";

// BLOG
export const BLOG_HOME = "/blog";
